import React from "react";
import { useState, useEffect } from "react";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";

import { partnerService } from '../../services/api/partner.service';

export const DoctorStenciel = ({ doctor, toggleParafa }) => {

    const [parafa, setParafa] = useState();
    const partener = sessionStorage.getItem("idPartener");

    useEffect(() => {
        partnerService.getStenciel({ partener: partener, doctor: doctor.id })
            .then(response => {
                if (response) {
                    setParafa('data:image/jpeg;base64,' + response.content);
                }

            });
    }, []);

    return (
        <>
            <Dialog title={"Parafa Medic"} onClose={toggleParafa}>
                <div className="div-parafa">
                    <img className="img-parafa" src={parafa} alt="parafa medic" />
                </div>
                <DialogActionsBar>
                    <button
                        className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                        onClick={toggleParafa}
                    >
                        Inchide
                    </button>
                </DialogActionsBar>
            </Dialog>
        </>
    );
}
